export type AppTheme = 'green' | 'black';

export interface GameSettings {
  ageGroup: string;
  halfDuration: number; // in minutes
  numberOfHalves: number;
  hasOvertime: boolean;
  overtimeDuration: number; // in minutes
  halfTimeBreakDuration: number; // in minutes
  homeTeamName: string;
  awayTeamName: string;
  homeTeamColor: string;
  awayTeamColor: string;
  notificationType: 'siren' | 'beep' | 'alert';
  theme: AppTheme;
}

export interface Card {
  id: string;
  team: 'home' | 'away';
  playerNumber: string;
  type: 'yellow' | 'red';
  timestamp: number;
  half: number;
  reason?: string;
}

export interface GameState {
  homeScore: number;
  awayScore: number;
  currentHalf: number;
  timeRemaining: number; // in seconds
  isRunning: boolean;
  isHalfTimeBreak: boolean;
  breakTimeRemaining: number; // in seconds
  cards: Card[];
  notes: string;
  startTimestamp?: number; // timestamp when timer was started
}

export const DEFAULT_SETTINGS: GameSettings = {
  ageGroup: 'U14',
  halfDuration: 35,
  numberOfHalves: 2,
  hasOvertime: false,
  overtimeDuration: 10,
  halfTimeBreakDuration: 5,
  homeTeamName: 'Home',
  awayTeamName: 'Away',
  homeTeamColor: '#3b82f6',
  awayTeamColor: '#ef4444',
  notificationType: 'siren',
  theme: 'green',
};

export const AGE_GROUP_PRESETS: Record<string, Partial<GameSettings>> = {
  'U8': { halfDuration: 20, numberOfHalves: 2 },   // Mini-soccer 5v5
  'U9': { halfDuration: 25, numberOfHalves: 2 },   // Mini-soccer 7v7
  'U10': { halfDuration: 25, numberOfHalves: 2 },  // Mini-soccer 7v7
  'U11': { halfDuration: 30, numberOfHalves: 2 },  // 9v9
  'U12': { halfDuration: 30, numberOfHalves: 2 },  // 9v9
  'U13': { halfDuration: 35, numberOfHalves: 2 },  // 11v11
  'U14': { halfDuration: 35, numberOfHalves: 2 },  // 11v11
  'U15': { halfDuration: 40, numberOfHalves: 2 },  // 11v11
  'U16': { halfDuration: 40, numberOfHalves: 2 },  // 11v11
  'U17': { halfDuration: 45, numberOfHalves: 2 },  // 11v11
  'U18': { halfDuration: 45, numberOfHalves: 2 },  // 11v11
  'Adult': { halfDuration: 45, numberOfHalves: 2 },
};

export interface SavedGame {
  id: string;
  timestamp: number;
  settings: GameSettings;
  finalScore: {
    home: number;
    away: number;
  };
  cards: Card[];
  notes: string;
}